import React from 'react';
import { Typography } from '@material-ui/core';

interface Props {
  children: React.ReactNode;
  style?: React.CSSProperties;
}

export function HeaderLabel({ children, style = {} }: Props) {
  return (
    <Typography
      variant="h2"
      style={{
        fontSize: 16,
        fontWeight: 700,
        marginBottom: 16,
        ...style,
      }}
    >
      {children}
    </Typography>
  );
}
